export default __webpack_public_path__ + "static/media/005-cow.01431ade.svg";